import React from "react";
import { FaInstagramSquare } from "react-icons/fa";
import { FaTwitterSquare } from "react-icons/fa";
import { FaFacebookSquare } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { Link } from "react-router-dom";

const SocialIcons = ({ links }) => {
  return (
    <div className="social-icons">
      <a href={links.instagram} target="_blank">
        <FaInstagramSquare />
      </a>
      <a href={links.twitter} target="_blank">
        <FaTwitterSquare />
      </a>
      <a href={links.facebook} target="_blank">
        <FaFacebookSquare />
      </a>
      <a href={links.linkedin} target="_blank">
        <FaLinkedin />
      </a>
    </div>
  );
};

export default SocialIcons;
